import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { useApi, useLoad } from "@/lib/api";
import { Panel } from "@/pages/console/Kit";

const CO = [["legal_name", "Legal name"], ["company_number", "Company number"], ["office", "Registered office"], ["country", "Registered in"], ["vat", "VAT number"], ["ico", "ICO registration"], ["email", "Support email"], ["booking_url", "Booking link"]];

export default function SiteSettings() {
  const api = useApi();
  const d = useLoad("/admin/content");
  const [co, setCo] = useState({});
  const [hero, setHero] = useState({ hero_title: "", hero_sub: "" });
  const [faqs, setFaqs] = useState("[]");
  const [spend, setSpend] = useState(0);
  useEffect(() => {
    if (!d.data) return;
    setCo(d.data.company); setSpend(d.data.marketing || 0);
    setHero({ hero_title: d.data.content.hero_title, hero_sub: d.data.content.hero_sub });
    setFaqs(JSON.stringify(d.data.content.faqs, null, 2));
  }, [d.data]);
  const saveCo = async () => { try { await api("put", "/admin/company", { company: co, marketing_spend_month: Number(spend) }); toast.success("Company details saved"); } catch (e) { toast.error(e.message); } };
  const saveContent = async () => {
    let parsed;
    try { parsed = JSON.parse(faqs); } catch { return toast.error("FAQs must be valid JSON"); }
    try { await api("put", "/admin/content", { content: { ...hero, faqs: parsed } }); toast.success("Website updated"); } catch (e) { toast.error(e.message); }
  };
  if (!d.data) return <p className="text-slate-400">Loading…</p>;
  return (
    <div className="grid gap-6 lg:grid-cols-2">
      <Panel title="Company details (website footer, legal pages, emails)" testid="console-company">
        <div className="space-y-2">
          {CO.map(([k, l]) => <label key={k} className="block text-xs font-semibold text-slate-600">{l}<Input value={co[k] || ""} onChange={(e) => setCo({ ...co, [k]: e.target.value })} className="mt-1" data-testid={`company-${k}-input`} /></label>)}
          <label className="block text-xs font-semibold text-slate-600">Marketing spend this month (£)<Input type="number" value={spend} onChange={(e) => setSpend(e.target.value)} className="mt-1" /></label>
          <Button onClick={saveCo} data-testid="company-save-button">Save company details</Button>
        </div>
      </Panel>
      <Panel title="Home page and FAQs" testid="console-content">
        <div className="space-y-2">
          <label className="block text-xs font-semibold text-slate-600">Headline<Input value={hero.hero_title} onChange={(e) => setHero({ ...hero, hero_title: e.target.value })} className="mt-1" data-testid="content-hero-title-input" /></label>
          <label className="block text-xs font-semibold text-slate-600">Sub-heading<Textarea rows={3} value={hero.hero_sub} onChange={(e) => setHero({ ...hero, hero_sub: e.target.value })} className="mt-1" /></label>
          <label className="block text-xs font-semibold text-slate-600">FAQs (list of question and answer)<Textarea rows={10} value={faqs} onChange={(e) => setFaqs(e.target.value)} className="mt-1 font-mono text-xs" /></label>
          <Button onClick={saveContent} data-testid="content-save-button">Publish website changes</Button>
        </div>
      </Panel>
    </div>
  );
}
